import ExportData from './ExportData.component';

export default ExportData;
